// // ============================================================
// // src/components/Services.js
// // ✅ Passes hospitalId to fetch only this hospital's services
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import { useHospital } from "../context/HospitalContext";

// const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// const DEFAULT_SERVICES = [
//   {
//     icon: "🦷",
//     name: "General Dentistry & Cleaning",
//     desc: "Comprehensive oral examinations, professional cleanings, cavity detection, and preventive care for lasting dental health.",
//     price: "Rs. 500",
//     from: true,
//   },
//   {
//     icon: "✨",
//     name: "Cosmetic Dentistry & Smile Makeover",
//     desc: "Transform your smile with veneers, bonding, whitening, and complete makeover packages designed to perfection.",
//     price: "Rs. 3,500",
//     from: true,
//   },
//   {
//     icon: "🔩",
//     name: "Dental Implants",
//     desc: "Permanent tooth replacements using titanium implants — the gold standard for missing teeth, built to last decades.",
//     price: "Rs. 25,000",
//     from: true,
//   },
//   {
//     icon: "📐",
//     name: "Orthodontics & Invisalign",
//     desc: "Traditional braces and clear aligner solutions to straighten teeth and correct bite issues at any age.",
//     price: "Rs. 18,000",
//     from: true,
//   },
//   {
//     icon: "💉",
//     name: "Root Canal Therapy",
//     desc: "Painless, single-appointment root canal treatments using rotary endodontics and advanced anesthesia techniques.",
//     price: "Rs. 4,000",
//     from: true,
//   },
//   {
//     icon: "👶",
//     name: "Pediatric Dentistry",
//     desc: "Gentle, child-friendly dental care from infancy through adolescence in our specially designed kids' suite.",
//     price: "Rs. 400",
//     from: true,
//   },
// ];

// export default function Services() {
//   const { hospital } = useHospital();
//   const [services, setServices] = useState(DEFAULT_SERVICES);

//   const fetchServices = useCallback(() => {
//     // ✅ Pass hospitalId as query param — gets THIS hospital's services only
//     const hospitalId = hospital?._id || "";
//     const url = hospitalId
//       ? `${BASE_URL}/services?hospitalId=${hospitalId}`
//       : `${BASE_URL}/services`;

//     fetch(url)
//       .then((r) => (r.ok ? r.json() : null))
//       .then((data) => {
//         if (data && data.length > 0) setServices(data);
//       })
//       .catch(() => {});
//   }, [hospital?._id]);

//   useEffect(() => {
//     fetchServices();
//     window.addEventListener("focus", fetchServices);
//     return () => window.removeEventListener("focus", fetchServices);
//   }, [fetchServices]);

//   useEffect(() => {
//     window.__refreshServices = fetchServices;
//     return () => {
//       delete window.__refreshServices;
//     };
//   }, [fetchServices]);

//   const scrollTo = (id) =>
//     document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

//   return (
//     <section className="services" id="services">
//       <div className="services-header">
//         <div>
//           <div className="section-tag">Our Services</div>
//           <h2 className="section-title">
//             Everything Your
//             <br />
//             <em>Smile Needs</em>
//           </h2>
//         </div>
//         <div className="section-desc">
//           Comprehensive dental care under one roof — from preventive treatments
//           to advanced cosmetic procedures, delivered with cutting-edge
//           technology.
//         </div>
//       </div>
//       <div className="services-grid">
//         {services.map((s, i) => (
//           <div className="service-card" key={i}>
//             <div className="service-icon">{s.icon}</div>
//             <h3>{s.name}</h3>
//             <p>{s.desc}</p>
//             <div className="service-price-tag">
//               <span className="price-from">{s.from ? "from " : ""}</span>
//               {s.price}
//             </div>
//             <button
//               className="service-link"
//               onClick={() => scrollTo("appointment")}
//             >
//               Book Now →
//             </button>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// }

// // ============================================================
// // src/components/Services.js
// // ✅ Specialty text wired via getSpecialtyText()
// // ============================================================
// import React, { useState, useEffect, useCallback } from "react";
// import { useHospital } from "../context/HospitalContext";
// import { getSpecialtyText } from "../utils/specialtyText";

// const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// const DEFAULT_SERVICES = [
//   {
//     icon: "🦷",
//     name: "General Dentistry & Cleaning",
//     desc: "Comprehensive oral examinations, professional cleanings, cavity detection, and preventive care for lasting dental health.",
//     price: "Rs. 500",
//     from: true,
//   },
//   {
//     icon: "✨",
//     name: "Cosmetic Dentistry & Smile Makeover",
//     desc: "Transform your smile with veneers, bonding, whitening, and complete makeover packages designed to perfection.",
//     price: "Rs. 3,500",
//     from: true,
//   },
//   {
//     icon: "🔩",
//     name: "Dental Implants",
//     desc: "Permanent tooth replacements using titanium implants — the gold standard for missing teeth, built to last decades.",
//     price: "Rs. 25,000",
//     from: true,
//   },
//   {
//     icon: "📐",
//     name: "Orthodontics & Invisalign",
//     desc: "Traditional braces and clear aligner solutions to straighten teeth and correct bite issues at any age.",
//     price: "Rs. 18,000",
//     from: true,
//   },
//   {
//     icon: "💉",
//     name: "Root Canal Therapy",
//     desc: "Painless, single-appointment root canal treatments using rotary endodontics and advanced anesthesia techniques.",
//     price: "Rs. 4,000",
//     from: true,
//   },
//   {
//     icon: "👶",
//     name: "Pediatric Dentistry",
//     desc: "Gentle, child-friendly dental care from infancy through adolescence in our specially designed kids' suite.",
//     price: "Rs. 400",
//     from: true,
//   },
// ];

// export default function Services() {
//   const { hospital } = useHospital();
//   const t = getSpecialtyText(hospital.type);
//   const [services, setServices] = useState(DEFAULT_SERVICES);

//   const fetchServices = useCallback(() => {
//     const hospitalId = hospital?._id || "";
//     const url = hospitalId
//       ? `${BASE_URL}/services?hospitalId=${hospitalId}`
//       : `${BASE_URL}/services`;
//     fetch(url)
//       .then((r) => (r.ok ? r.json() : null))
//       .then((data) => {
//         if (data && data.length > 0) setServices(data);
//       })
//       .catch(() => {});
//   }, [hospital?._id]);

//   useEffect(() => {
//     fetchServices();
//     window.addEventListener("focus", fetchServices);
//     return () => window.removeEventListener("focus", fetchServices);
//   }, [fetchServices]);

//   useEffect(() => {
//     window.__refreshServices = fetchServices;
//     return () => {
//       delete window.__refreshServices;
//     };
//   }, [fetchServices]);

//   const scrollTo = (id) =>
//     document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

//   return (
//     <section className="services" id="services">
//       <div className="services-header">
//         <div>
//           {/* ✅ Specialty text */}
//           <div className="section-tag">{t.servicesTag}</div>
//           <h2 className="section-title">
//             {t.servicesTitle.includes(" ") ? (
//               (() => {
//                 const words = t.servicesTitle.split(" ");
//                 const half = Math.ceil(words.length / 2);
//                 return (
//                   <>
//                     {words.slice(0, half).join(" ")}
//                     <br />
//                     <em>{words.slice(half).join(" ")}</em>
//                   </>
//                 );
//               })()
//             ) : (
//               <>{t.servicesTitle}</>
//             )}
//           </h2>
//         </div>
//         <div className="section-desc">{t.servicesDesc}</div>
//       </div>
//       <div className="services-grid">
//         {services.map((s, i) => (
//           <div className="service-card" key={i}>
//             <div className="service-icon">{s.icon}</div>
//             <h3>{s.name}</h3>
//             <p>{s.desc}</p>
//             <div className="service-price-tag">
//               <span className="price-from">{s.from ? "from " : ""}</span>
//               {s.price}
//             </div>
//             <button
//               className="service-link"
//               onClick={() => scrollTo("appointment")}
//             >
//               Book Now →
//             </button>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// }

// ============================================================
// src/components/Services.js
// ✅ Specialty-specific default services per hospital type
// ============================================================
import React, { useState, useEffect, useCallback } from "react";
import { useHospital } from "../context/HospitalContext";
import { getSpecialtyText } from "../utils/specialtyText";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// ✅ Default services per specialty
const DEFAULT_SERVICES_BY_TYPE = {
  dental: [
    {
      icon: "🦷",
      name: "General Dentistry & Cleaning",
      desc: "Comprehensive oral examinations, professional cleanings, cavity detection, and preventive care for lasting dental health.",
      price: "Rs. 500",
      from: true,
    },
    {
      icon: "✨",
      name: "Cosmetic Dentistry & Smile Makeover",
      desc: "Transform your smile with veneers, bonding, whitening, and complete makeover packages designed to perfection.",
      price: "Rs. 3,500",
      from: true,
    },
    {
      icon: "🔩",
      name: "Dental Implants",
      desc: "Permanent tooth replacements using titanium implants — the gold standard for missing teeth, built to last decades.",
      price: "Rs. 25,000",
      from: true,
    },
    {
      icon: "📐",
      name: "Orthodontics & Invisalign",
      desc: "Traditional braces and clear aligner solutions to straighten teeth and correct bite issues at any age.",
      price: "Rs. 18,000",
      from: true,
    },
    {
      icon: "💉",
      name: "Root Canal Therapy",
      desc: "Painless, single-appointment root canal treatments using rotary endodontics and advanced anesthesia techniques.",
      price: "Rs. 4,000",
      from: true,
    },
    {
      icon: "👶",
      name: "Pediatric Dentistry",
      desc: "Gentle, child-friendly dental care from infancy through adolescence in our specially designed kids' suite.",
      price: "Rs. 400",
      from: true,
    },
  ],
  ayurved: [
    {
      icon: "🌿",
      name: "Panchakarma Detox",
      desc: "Complete body detoxification through five classical Ayurvedic therapies to restore balance and eliminate toxins.",
      price: "Rs. 8,000",
      from: true,
    },
    {
      icon: "💆",
      name: "Shirodhara Therapy",
      desc: "Continuous pouring of warm medicated oil on the forehead to calm the nervous system and relieve stress, anxiety and insomnia.",
      price: "Rs. 2,500",
      from: true,
    },
    {
      icon: "🤲",
      name: "Abhyanga (Full Body Massage)",
      desc: "Traditional full-body Ayurvedic massage with warm herbal oils to improve circulation, reduce pain and nourish the skin.",
      price: "Rs. 1,800",
      from: true,
    },
    {
      icon: "🌸",
      name: "Nasya Treatment",
      desc: "Herbal oil administration through nasal passages to treat sinusitis, migraine, hair fall and enhance mental clarity.",
      price: "Rs. 1,200",
      from: true,
    },
    {
      icon: "🌱",
      name: "Kati Basti (Back Pain Relief)",
      desc: "Warm medicated oil treatment retained on the lower back to relieve chronic back pain, disc problems and sciatica.",
      price: "Rs. 2,000",
      from: true,
    },
    {
      icon: "✨",
      name: "Skin & Beauty Treatments",
      desc: "Ayurvedic face packs, Udvartana and herbal skin therapies for natural glow, anti-aging and skin rejuvenation.",
      price: "Rs. 1,500",
      from: true,
    },
  ],
  ortho: [
    {
      icon: "🦴",
      name: "Joint Replacement Surgery",
      desc: "Advanced knee, hip and shoulder replacement surgeries using the latest implants and minimally invasive surgical techniques.",
      price: "Rs. 1,20,000",
      from: true,
    },
    {
      icon: "🏃",
      name: "Sports Injury Treatment",
      desc: "Comprehensive diagnosis and treatment for ligament tears, muscle injuries, fractures and sports-related orthopedic conditions.",
      price: "Rs. 5,000",
      from: true,
    },
    {
      icon: "🦵",
      name: "Knee Replacement",
      desc: "Total and partial knee replacement surgery to relieve severe arthritis pain and restore full mobility and quality of life.",
      price: "Rs. 90,000",
      from: true,
    },
    {
      icon: "🧠",
      name: "Spine Surgery",
      desc: "Advanced spinal procedures including disc replacement, laminectomy and spinal fusion for back pain and nerve compression relief.",
      price: "Rs. 1,50,000",
      from: true,
    },
    {
      icon: "🏥",
      name: "Physiotherapy & Rehabilitation",
      desc: "Personalised physiotherapy programs for post-surgical recovery, sports injuries and chronic musculoskeletal conditions.",
      price: "Rs. 800",
      from: true,
    },
    {
      icon: "💊",
      name: "Arthritis Management",
      desc: "Comprehensive non-surgical management of osteoarthritis and rheumatoid arthritis through injections, medication and therapy.",
      price: "Rs. 2,000",
      from: true,
    },
  ],
  eye: [
    {
      icon: "👁️",
      name: "LASIK Laser Eye Surgery",
      desc: "Bladeless, painless laser vision correction to permanently eliminate spectacles and contact lenses with 99% success rate.",
      price: "Rs. 35,000",
      from: true,
    },
    {
      icon: "🔬",
      name: "Cataract Surgery",
      desc: "Advanced phacoemulsification cataract surgery with premium IOL implants for crystal-clear vision restoration.",
      price: "Rs. 45,000",
      from: true,
    },
    {
      icon: "👁️",
      name: "Glaucoma Treatment",
      desc: "Early detection and complete management of glaucoma including laser therapy and surgery to prevent permanent vision loss.",
      price: "Rs. 3,500",
      from: true,
    },
    {
      icon: "🏥",
      name: "Retina Treatment",
      desc: "Advanced treatment for diabetic retinopathy, macular degeneration and retinal detachment using laser and surgical procedures.",
      price: "Rs. 8,000",
      from: true,
    },
    {
      icon: "✨",
      name: "Squint Correction",
      desc: "Surgical and non-surgical correction of squint (strabismus) in children and adults for proper eye alignment and vision.",
      price: "Rs. 25,000",
      from: true,
    },
    {
      icon: "👶",
      name: "Pediatric Ophthalmology",
      desc: "Specialised eye care for children including vision screening, lazy eye treatment and children's spectacle prescriptions.",
      price: "Rs. 600",
      from: true,
    },
  ],
  cardiology: [
    {
      icon: "❤️",
      name: "Coronary Angiography",
      desc: "Minimally invasive cardiac catheterization to diagnose coronary artery disease and identify blockages in heart arteries.",
      price: "Rs. 18,000",
      from: true,
    },
    {
      icon: "💊",
      name: "Angioplasty & Stenting",
      desc: "Advanced balloon angioplasty and stent placement to open blocked coronary arteries and restore normal blood flow to the heart.",
      price: "Rs. 2,00,000",
      from: true,
    },
    {
      icon: "🏥",
      name: "Open Heart Surgery (CABG)",
      desc: "Coronary artery bypass grafting surgery for multiple blockages — restoring full cardiac function and quality of life.",
      price: "Rs. 3,50,000",
      from: true,
    },
    {
      icon: "⚡",
      name: "Pacemaker Implantation",
      desc: "Permanent pacemaker and ICD implantation for heart rhythm disorders, bradycardia and heart failure management.",
      price: "Rs. 1,20,000",
      from: true,
    },
    {
      icon: "🔬",
      name: "Preventive Cardiology",
      desc: "Complete cardiac risk assessment, lipid management and lifestyle modification programs to prevent heart disease before it starts.",
      price: "Rs. 3,500",
      from: true,
    },
    {
      icon: "👶",
      name: "Pediatric Cardiology",
      desc: "Specialised diagnosis and treatment of congenital heart defects and cardiac conditions in newborns, infants and children.",
      price: "Rs. 2,000",
      from: true,
    },
  ],
  pediatric: [
    {
      icon: "👶",
      name: "Newborn & Neonatal Care",
      desc: "Comprehensive care for newborns including screening, vaccination, growth monitoring and neonatal intensive care if needed.",
      price: "Rs. 1,000",
      from: true,
    },
    {
      icon: "💉",
      name: "Vaccination & Immunization",
      desc: "Complete childhood immunization as per IAP schedule including all routine and special vaccines with expert guidance.",
      price: "Rs. 500",
      from: true,
    },
    {
      icon: "📈",
      name: "Growth & Development Monitoring",
      desc: "Regular assessment of physical, mental and developmental milestones to ensure your child is growing healthy and on track.",
      price: "Rs. 600",
      from: true,
    },
    {
      icon: "🍎",
      name: "Child Nutrition Counseling",
      desc: "Expert dietary guidance for healthy weight, managing malnutrition, food allergies and age-appropriate nutrition plans.",
      price: "Rs. 800",
      from: true,
    },
    {
      icon: "🫁",
      name: "Pediatric Respiratory Care",
      desc: "Treatment of asthma, bronchitis, pneumonia and all respiratory conditions in children with child-friendly procedures.",
      price: "Rs. 1,200",
      from: true,
    },
    {
      icon: "🏥",
      name: "24/7 Pediatric Emergency",
      desc: "Round-the-clock emergency pediatric care for fever, injuries, seizures and all urgent child health conditions.",
      price: "Rs. 1,500",
      from: true,
    },
  ],
  general: [
    {
      icon: "🏥",
      name: "General Medicine & OPD",
      desc: "Expert consultation for all general health conditions including fever, infections, diabetes, hypertension and lifestyle diseases.",
      price: "Rs. 500",
      from: true,
    },
    {
      icon: "🔬",
      name: "Pathology & Diagnostics",
      desc: "Comprehensive blood tests, urine analysis, imaging and advanced diagnostics with accurate results and quick turnaround.",
      price: "Rs. 300",
      from: true,
    },
    {
      icon: "🚑",
      name: "Emergency & Trauma Care",
      desc: "24/7 emergency services with fully equipped trauma centre, ICU and rapid response team for all medical emergencies.",
      price: "Rs. 2,000",
      from: true,
    },
    {
      icon: "🦴",
      name: "Orthopedics & Joint Care",
      desc: "Expert management of bone fractures, joint pain, arthritis and orthopedic surgeries by experienced orthopedic specialists.",
      price: "Rs. 1,500",
      from: true,
    },
    {
      icon: "❤️",
      name: "Cardiology & Heart Care",
      desc: "Complete cardiac services from ECG and echo to angiography and cardiac surgery by expert cardiologists.",
      price: "Rs. 2,500",
      from: true,
    },
    {
      icon: "🤰",
      name: "Gynecology & Maternity Care",
      desc: "Comprehensive women's health services including antenatal care, normal and cesarean delivery, and gynecological procedures.",
      price: "Rs. 1,000",
      from: true,
    },
  ],
};

export default function Services() {
  const { hospital } = useHospital();
  const t = getSpecialtyText(hospital.type);

  // ✅ Use specialty-specific defaults
  const type = (hospital.type || "dental").toLowerCase();
  const defaultServices =
    DEFAULT_SERVICES_BY_TYPE[type] || DEFAULT_SERVICES_BY_TYPE.dental;

  const [services, setServices] = useState(defaultServices);

  const fetchServices = useCallback(() => {
    const hospitalId = hospital?._id || "";
    const url = hospitalId
      ? `${BASE_URL}/services?hospitalId=${hospitalId}`
      : `${BASE_URL}/services`;
    fetch(url)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data && data.length > 0) setServices(data);
        else setServices(defaultServices); // ✅ Fall back to specialty default
      })
      .catch(() => setServices(defaultServices));
  }, [hospital?._id, hospital?.type]); // eslint-disable-line

  useEffect(() => {
    fetchServices();
    window.addEventListener("focus", fetchServices);
    return () => window.removeEventListener("focus", fetchServices);
  }, [fetchServices]);

  useEffect(() => {
    window.__refreshServices = fetchServices;
    return () => {
      delete window.__refreshServices;
    };
  }, [fetchServices]);

  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section className="services" id="services">
      <div className="services-header">
        <div>
          <div className="section-tag">{t.servicesTag}</div>
          <h2 className="section-title">
            {(() => {
              const words = t.servicesTitle.split(" ");
              const half = Math.ceil(words.length / 2);
              return (
                <>
                  {words.slice(0, half).join(" ")}
                  <br />
                  <em>{words.slice(half).join(" ")}</em>
                </>
              );
            })()}
          </h2>
        </div>
        <div className="section-desc">{t.servicesDesc}</div>
      </div>
      <div className="services-grid">
        {services.map((s, i) => (
          <div className="service-card" key={i}>
            <div className="service-icon">{s.icon}</div>
            <h3>{s.name}</h3>
            <p>{s.desc}</p>
            <div className="service-price-tag">
              <span className="price-from">{s.from ? "from " : ""}</span>
              {s.price}
            </div>
            <button
              className="service-link"
              onClick={() => scrollTo("appointment")}
            >
              Book Now →
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}
